/**
 * Encabezado opcional del API (reportes tipo impreso).
 * @typedef {Object} EncabezadoReporteApi
 * @property {string} [nombreComercial]
 * @property {string} [razonSocial]
 * @property {string} [domicilioFiscal]
 * @property {string} [rfc]
 * @property {string} [reporteTitulo]
 * @property {string} [cortesias]
 * @property {string} [periodoTexto]
 * @property {string} [periodoDesde]
 * @property {string} [periodoHasta]
 * @property {string} [cajasTexto]
 * @property {string} [turnosTexto]
 * @property {string} [bloqueTexto]
 * @property {string|null} [logoPath]
 * @property {string} [responsable]
 * @property {string} [nombreResponsable]
 * @property {string} [representante]
 * @property {string} [representanteLegal]
 * @property {string} [nombreCompletoUsuario]
 */

function trimTruthy(v) {
  if (v == null) return false;
  if (typeof v === 'string') return v.trim().length > 0;
  return true;
}

export function hasEncabezadoUtil(encabezado) {
  return encabezado != null && typeof encabezado === 'object' && Object.keys(encabezado).length > 0;
}

/** Hay datos útiles para pintar encabezado (evita `{}` vacío). */
export function encabezadoTieneDatos(encabezado) {
  if (!hasEncabezadoUtil(encabezado)) return false;
  const e = encabezado;
  return Boolean(
    trimTruthy(e.bloqueTexto) ||
    trimTruthy(e.nombreComercial) ||
    trimTruthy(e.reporteTitulo) ||
    trimTruthy(e.razonSocial) ||
    trimTruthy(e.rfc) ||
    trimTruthy(e.responsable) ||
    trimTruthy(e.nombreResponsable) ||
    trimTruthy(e.periodoTexto) ||
    trimTruthy(e.cajasTexto) ||
    trimTruthy(e.turnosTexto)
  );
}
